module.exports = __webpack_public_path__ + "static/media/profile-admin.e7275431.svg";